import util from '@bmp-vue/core/api/util'
const controller = 'TokenNumerico'
export default Object.assign({}, util.GetCrud(controller, ['post']), {
  EnviarToken: function (dto) {
    return util.Axios.Post(controller + '/EnviarToken', dto)
  },
  ReenviarToken: function (dto) {
    return util.Axios.Post(controller + '/ReenviarToken', dto)
  },
  ValidaToken (dto) {
    return util.Axios.Post(controller + '/ValidaToken', dto)
  },
  TipoEnvioTokenNumericoEnum: {
    Email: 1,
    SMS: 2,
    WhatsApp: 3
  }
})
